import { Smile, Leaf, Heart, Moon, CloudRain, Zap, Flame } from "lucide-react";

export const MOODS = [
  { key: "happy", icon: Smile, color: "#F0D375" },
  { key: "calm", icon: Leaf, color: "#6EE7B7" },
  { key: "grateful", icon: Heart, color: "#F9A8D4" },
  { key: "tired", icon: Moon, color: "#A5B4FC" },
  { key: "sad", icon: CloudRain, color: "#93C5FD" },
  { key: "anxious", icon: Zap, color: "#FCD34D" },
  { key: "angry", icon: Flame, color: "#FCA5A5" },
];
